/**
 * Service that wraps around the masterData object.
 * Used for utility methods and caching.
 */

var VRC = VRC || {};

VRC.MasterDataService = (function () {
	var _portTypes = {
		base: 'base',
		rig: 'rig',
		harbour: 'harbour',
		position: 'position',
		vessel: 'vessel'
	};

	var _groupedPorts;

	var init = function (p_owner) {

		if (p_owner) {
			g_timeStampFormat = p_owner.master_data.locale_settings.datetimeFormat ? p_owner.master_data.locale_settings.datetimeFormat : 'DD.MM.YYYY HH:mm';
			g_dateFormat = p_owner.master_data.locale_settings.dateFormat ? p_owner.master_data.locale_settings.datetimeFormat : 'DD.MM.YYYY';
			g_app_locale = p_owner.master_data.locale_settings.timeZone ? p_owner.master_data.locale_settings.timeZone : 'Europe/Oslo';
			var env =  p_owner.master_data.env;
			VRC.VoyageNoView.updateEnvironment(env.server);
			moment.tz.setDefault(g_app_locale);
		}

		VRC.ConversionUnitService.init(g_master_data.master_data.conversion_units);
	};

	var getPorts = function () {
		return g_master_data.master_data.port_list;
	};

	var getVessels = function () {
		return g_master_data.GetList('vessel_list');
	};

	var getGroupedPorts = function () {
		var ports = getPorts();
		var vessels = getVessels();
		var subEventCode = 'noSubEvent';
		vessels = _.map(vessels, function (vessel) {
			return {id: 'vessel-' + vessel.id, name: vessel.name}
		});

		_groupedPorts = {
			active: _.filter(ports, function (port) {
				return port.isActive === 'true'
			}),
			rig: _.filter(ports, function (port) {
				return port.type === _portTypes.rig && port.isAvailable === 'true'
			}),
			port: _.filter(ports, function (port) {
				return (port.type === _portTypes.harbour || port.type === _portTypes.base)
			}),
			position: _.filter(ports, function (port) {
				return port.type === _portTypes.position
			}),
			vessel: _.filter(vessels, function (vessel) {
				return g_current_page == G_PAGE.BULK_PAGE

			})
		};

		return _groupedPorts;
	};

	var getCompany = function (companyId) {
		var companyList = g_master_data.master_data.company_list;
		var company = _.find(companyList, function (company) {
			return company.id == companyId;
		});

		return company;
	};

	var getQuaysByPort = function (portId) {
		var quays = [];
		var port = getPort(portId);

		if (!port) {
			quays = [];
		}
		else {
			quays = port.quays || [];
		}

		return quays;
	};

	var getPort = function (portId) {
		var portList = g_master_data.master_data.port_list;
		var port = _.find(portList, function (port) {

			return port.id == portId;
		});

		return port;
	};

	var getVessel = function(vesselId) {
		if (vesselId) {
			var vesselList = g_master_data.GetList('vessel_list');
			return _.find(vesselList, function (vessel) {
				return vessel.id == vesselId.split('-')[1]
			});
		}
	};

	var isRig = function (port) {
		if (!port) {
			return false;
		}
		return port.type === _portTypes.rig;
	};

	var getInside500mZonePosition = function () {
		return g_master_data.master_data.settings ? g_master_data.master_data.settings.inside500mZonePosition : '';
    };

	var getDisplayPort = function (destinationId, originId) {
		var name = 'No rig as origin/destination';
		var destination = getPort(destinationId);
		var origin = getPort(originId);

		if (isRig(destination)) {
			name = destination.name;
		}
		else if (isRig(origin)) {
			name = origin.name;
		}

		return name;
	};

	var getBulkMatrixLegend = function () {

	};

	var getColour = function (destinationId, originId) {
		var colour = G_CONTAINER_COLOURS.DECK;
		var destination = getPort(destinationId);
		var origin = getPort(originId);

		if (isRig(destination)) {
			colour = destination.colour;
		}
		else if (isRig(origin)) {
			colour = origin.colour;
		}

		return colour;
	};

	var getBulkType = function (bulkTypeId) {
		var bulkTypeList = g_master_data.master_data.bulk_type_list;
		var bulkType = _.find(bulkTypeList, function (bulkType) {
			return bulkType.id == bulkTypeId;
		});

		return bulkType;
	};

	var getBulkTypeNameAndIs = function (filter) {

		var bulkTypeList = g_master_data.master_data.bulk_type_list;

		if (filter) {
			bulkTypeList = _.filter(bulkTypeList, filter);
		}

		return _.map(bulkTypeList, function (bulkType) {
			return {name: bulkType.name, id: bulkType.id};
		});
	};

	var getDgSegRule = function (dgClass, dgClass2) {
		var dgSegregationRules = g_master_data.master_data.dg_segregation_rules;

		try {
			return dgSegregationRules[dgClass][dgClass2];
		}
		catch (e) {
			return null;
		}
	};

	var getDgClasses = function () {
		return g_master_data.master_data.dg_classes;
	};

	var getDgClass = function(dgClassId){
		return _.find(getDgClasses(), function(dgClass){
			return dgClass.id == dgClassId;
		});
	};

	var getContainerTypes = function () {
		return g_master_data.GetList('container_type_list');
	};

	var getContainerTemplates = function () {
		return g_master_data.GetList('container_default_unit_list')
	};

	var getBulkValueUnits = function () {
		return g_master_data.master_data.bulk_value_unit_list;
	};

	var getBulkValueUnitsAsArray = function () {

		return _.pluck(g_master_data.master_data.bulk_value_unit_list, "name");
	};

	var getValueUnitPreferences = function () {
		return g_master_data.master_data.value_unit_preferences;
	};

	var getBulkCleanTypes = function () {
		return g_master_data.master_data.bulk_clean_type_list;
	};

	var getBulkCleanType = function (actionObject) {
		var bulk_clean_type_list = getBulkCleanTypes();
		var type = _.find(bulk_clean_type_list, function (type) {
			return type.id == actionObject;
		});

		return type;
	};

	var getEventCode = function (eventCode) {

		var eventTypeList = g_master_data.master_data.event_type_list;
		var event = _.find(eventTypeList, function (eventType) {
			return eventType.id == eventCode;
		});

		return event ? event.event_code : undefined
	};

	return {
		getVessel : getVessel,
		getCompany: getCompany,
		getPort: getPort,
		getPorts: getPorts,
		getGroupedPorts: getGroupedPorts,
		getBulkType: getBulkType,
		getColour: getColour,
		getDisplayPort: getDisplayPort,
		getDgSegRule: getDgSegRule,
		getDgClass : getDgClass,
		getBulkValueUnits: getBulkValueUnits,
		getBulkValueUnitsAsArray: getBulkValueUnitsAsArray,
		getValueUnitPreferences: getValueUnitPreferences,
		getBulkTypeNameAndIs: getBulkTypeNameAndIs,
		getQuaysByPort: getQuaysByPort,
		getDgClasses: getDgClasses,
		getContainerTypes: getContainerTypes,
		getContainerTemplates: getContainerTemplates,
        getInside500mZonePosition: getInside500mZonePosition,
		getBulkCleanTypes: getBulkCleanTypes,
		getBulkCleanType: getBulkCleanType,
		getEventCode: getEventCode,
		isRig: isRig,
		init: init
	}
})();

